import { Step } from '@shared/claim/steps';
export const handleMaintenance = (store) => {
    store.commit('pages/SET_ACTIVE_STEP', Step.Maintenance);
};
